import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import favoriteModalStateAtom from './favoriteModalStateAtom';
import defaultValue from './defaultValue';
const useSetFavoriteModalState = () => {
  const $ = _c(2);
  const setFavoriteModalStateAtom = useSetAtom(favoriteModalStateAtom);
  let t0;
  if ($[0] !== setFavoriteModalStateAtom) {
    t0 = t1 => {
      const {
        productId
      } = t1;
      if (productId) {
        setFavoriteModalStateAtom({
          isOpen: true,
          productId
        });
      } else {
        setFavoriteModalStateAtom(defaultValue);
      }
    };
    $[0] = setFavoriteModalStateAtom;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const setFavoriteModalState = t0;
  return setFavoriteModalState;
};
export default useSetFavoriteModalState;